var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound mt-5 pt-5"},[_c('div',{staticClass:"mt-5 pt-5"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.langDec['notfound']))]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.goToHome()}}},[_vm._v(_vm._s(_vm.langDec['homepage']))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }